webpackJsonp([79],{

/***/ 2410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumNewPostForm_vue__ = __webpack_require__(3545);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a74d1350_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumNewPostForm_vue__ = __webpack_require__(4311);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4309)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumNewPostForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a74d1350_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumNewPostForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/ForumNewPostForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a74d1350", Component.options)
  } else {
    hotAPI.reload("data-v-a74d1350", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_wrapper_mixin__ = __webpack_require__(509);
//
//
//
//
//
//
//
//
//
//
//
//




var messages = {
    es: {
        'time-picker.select-hour': 'Seleccione una hora',
        'time-picker.decrement': 'Disminuir',
        'time-picker.increment': 'Aumentar',
        'time-picker.no-time-selected': 'Hora no seleccionada',
        'time-picker.current-time': 'hora actual',
        'time-picker.reset-btn': 'Resetear'
    },
    en: {
        'time-picker.select-hour': 'Select a time',
        'time-picker.decrement': 'Decrease',
        'time-picker.increment': 'Increase',
        'time-picker.no-time-selected': 'Hour not selected',
        'time-picker.current-time': 'Current time',
        'time-picker.reset-btn': 'Reset'
    },
    pt: {
        'time-picker.select-hour': 'Selecione um horário',
        'time-picker.decrement': 'Decremento',
        'time-picker.increment': 'Incremento',
        'time-picker.no-time-selected': 'Hora não selecionada',
        'time-picker.current-time': 'Hora atual',
        'time-picker.reset-btn': 'Redefinir'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_wrapper_mixin__["a" /* default */])(String)],
    i18n: {
        messages: messages
    },
    components: {
        BFormTimepicker: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["B" /* BFormTimepicker */],
        BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */]
    },
    props: {
        showSeconds: Boolean,
        resetButtton: Boolean,
        noMarginBottom: Boolean,
        label: {
            type: String,
            required: false,
            default: ''
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        resetButton: {
            type: Boolean,
            default: true
        },
        nowButton: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: function _default() {
                return this.$t('time-picker.selectHour');
            }
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ 3051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTimepicker_vue__ = __webpack_require__(2885);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db34ee2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTimepicker_vue__ = __webpack_require__(3054);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3052)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db34ee2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTimepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db34ee2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTimepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseTimepicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db34ee2c", Component.options)
  } else {
    hotAPI.reload("data-v-db34ee2c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3052:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3053);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0d3d7551", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db34ee2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseTimepicker.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db34ee2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseTimepicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3053:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-db34ee2c]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-db34ee2c],.slide-down-leave-active[data-v-db34ee2c]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-db34ee2c],.slide-down-leave-to[data-v-db34ee2c]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-db34ee2c],.slide-fade-left-leave-active[data-v-db34ee2c]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-db34ee2c],.slide-fade-left-leave-to[data-v-db34ee2c]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-db34ee2c]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-db34ee2c],.fade-leave-to[data-v-db34ee2c]{opacity:0\n}\n", ""]);

// exports


/***/ }),

/***/ 3054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          class: { "no-margin-bottom": _vm.noMarginBottom },
          staticStyle: { "text-align": "initial !important" },
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c(
            "div",
            [
              _c("b-form-timepicker", {
                attrs: {
                  placeholder: _vm.placeholder,
                  "label-close-button": _vm.$t("close"),
                  "label-decrement": _vm.$t("time-picker.decrement"),
                  "label-increment": _vm.$t("time-picker.increment"),
                  "reset-button": _vm.resetButton,
                  "label-hours": _vm.$t("hours"),
                  "label-minutes": _vm.$t("minutes"),
                  "label-seconds": _vm.$t("seconds"),
                  "label-no-time-selected": _vm.$t(
                    "time-picker.no-time-selected"
                  ),
                  "label-now-button": _vm.$t("time-picker.current-time"),
                  dropup: "",
                  "label-reset-button": _vm.$t("time-picker.reset-btn"),
                  locale: _vm.$i18nHelpers.getNormalizedLocale(),
                  "show-seconds": _vm.showSeconds,
                  "close-button-variant": "secondary",
                  "now-button": _vm.nowButton
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("input", $event)
                  }
                },
                model: {
                  value: _vm.localValue,
                  callback: function($$v) {
                    _vm.localValue = $$v
                  },
                  expression: "localValue"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db34ee2c", esExports)
  }
}

/***/ }),

/***/ 3545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_typeahead__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseDatepicker__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_forms_BaseTimepicker__ = __webpack_require__(3051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_editor__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_vue_select__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repositories_ForumRepository__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repositories_GeographyRepository__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_db_countries__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_global_helpers__ = __webpack_require__(47);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var DISEASE_ID = '636255813ed3088c26324069';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forum-new-post-form',
  components: {
    'base-input': function baseInput() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 214)).then(function (m) {
        return m.default;
      });
    },
    'base-button': function baseButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 124)).then(function (m) {
        return m.default;
      });
    },
    BFormFile: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["q" /* BFormFile */],
    VueBootstrapTypeahead: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_typeahead__["a" /* default */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["r" /* BFormGroup */],
    BaseDatepicker: __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseDatepicker__["default"],
    BaseTimepicker: __WEBPACK_IMPORTED_MODULE_5__components_base_forms_BaseTimepicker__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_6_vue2_editor__["a" /* VueEditor */]
  },
  props: {},
  data: function data() {
    return {
      wysiwygInput: null,
      getPostNotifications: null,
      postTitle: null,
      postImage: null,
      category: null,
      tags: [],
      expirationDate: null,
      tagsSource: [],
      categoriesSource: [],
      tagsSourceFull: [],
      categoriesSourceFull: [],
      diseasesSource: [],
      showDiseaseInput: false,
      disease: null,
      sectionSource: [],
      section: null,
      activitySource: [],
      activityLevelSource: [],
      countrySource: [],
      stateSource: [],
      citySource: [],
      startDate: null,
      startHour: null,
      endDate: null,
      endHour: null,
      editingEntry: null,
      whoInData: {
        country: __WEBPACK_IMPORTED_MODULE_13__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_12__constants_db_countries__["a" /* MX_COUNTRY_ID */] : __WEBPACK_IMPORTED_MODULE_12__constants_db_countries__["b" /* SPAIN_COUNTRY_ID */],
        state: null,
        city: null,
        address: null,
        activity: null,
        otherActivity: null,
        activityLevel: null,
        startDate: null,
        endDate: null,
        commentaries: null,
        participantsLimit: null,
        noStartTime: null,
        noEndTime: null
      }
    };
  },
  created: function created() {
    this.$store.state.loading = false;
    if (this.inWhoInSection) {
      this.getActivities();
      this.getActivitiesLevel();
      this.editingEntry = null;
      if (this.$store.state.forum.editingEntry) {
        this.editingEntry = true;
        this.$store.state.forum.editingEntry = false;
        this.fillWhoInData();
      } else {
        this.getCountries();
        this.getStates();
      }
    } else {
      this.$store.state.forum.sectionId = __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */];
      this.getTags();
      this.getCategories();
      this.getSections();
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_forum_mixin__["a" /* default */]],
  computed: {
    getForumTitle: function getForumTitle() {
      if (this.inWhoInSection) {
        return this.$t('newActivity');
      } else if (this.showSectionSelector() && !this.section) {
        return this.$t('newPostTitle', ['']);
      } else if (this.showSectionSelector() && this.section) {
        return this.$t('newPostTitle', [this.getForumSectionTitle(this.section.id, true)]);
      } else {
        return this.$t('newPostTitle', [this.getForumSectionTitle(this.$store.state.forum.sectionId, true)]);
      }
    },
    otherActivitySelected: function otherActivitySelected() {
      return this.whoInData.activity === -1;
    },
    showCategorySelector: function showCategorySelector() {
      return !this.section && (this.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */] || this.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */]) || this.section && (this.section.id === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */] || this.section.id === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */]);
    },
    showtagsSelector: function showtagsSelector() {
      return !this.section && this.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */] || this.section && this.section.id === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */];
    }
  },
  methods: {
    sendForumForm: function sendForumForm() {
      if (this.inWhoInSection) {
        this.sendWhoInData();
      } else {
        this.sendForumData();
      }
    },
    back: function back() {
      window.history.back();
    },
    sendWhoInData: function sendWhoInData() {
      var _this = this;

      if (this.startHour && !this.startDate) {
        this.$store.dispatch('showDangerAlert', this.$t('startDateNotSelected'));
      } else if (this.startDate && this.startHour) {
        this.whoInData.startDate = new Date('' + this.startDate + (this.startHour ? 'T' + this.startHour : ''));
        this.whoInData.noStartTime = !this.startHour;
      } else {
        this.whoInData.startDate = null;
      }
      if (this.endHour && !this.endDate) {
        this.$store.dispatch('showDangerAlert', this.$t('endDateNotSelected'));
      } else if (this.endDate && this.endHour) {
        this.whoInData.endDate = new Date('' + this.endDate + (this.endHour ? 'T' + this.endHour : ''));
        this.whoInData.noEndTime = !this.endHour;
      } else {
        this.whoInData.endDate = null;
      }
      if (this.wysiwygInput) this.whoInData.commentaries = this.wysiwygInput;
      if (this.postTitle) this.whoInData.title = this.postTitle;
      if (!this.whoInData.activity) {
        this.$store.dispatch('showDangerAlert', this.$t('mustSelectActivity'));
      } else if (this.whoInData.activity === -1 && !this.whoInData.otherActivity) {
        this.$store.dispatch('showDangerAlert', this.$t('mustInsertOtherActivity'));
      } else if (!this.whoInData.activityLevel) {
        this.$store.dispatch('showDangerAlert', this.$t('mustSelectActivityLevel'));
      } else if (!this.whoInData.state) {
        this.$store.dispatch('showDangerAlert', this.$t('mustSelectState'));
      } else if (!this.whoInData.city) {
        this.$store.dispatch('showDangerAlert', this.$t('mustSelectCity'));
      } else if (!this.whoInData.address) {
        this.$store.dispatch('showDangerAlert', this.$t('mustSelectAddress'));
      } else if (this.whoInData.startDate && this.whoInData.startDate < new Date()) {
        this.$store.dispatch('showDangerAlert', this.$t('dateStartGreaterThanToday'));
      } else if (this.whoInData.endDate && this.whoInData.endDate < new Date()) {
        this.$store.dispatch('showDangerAlert', this.$t('dateEndGreaterThanToday'));
      } else if (this.whoInData.startDate && this.whoInData.endDate && this.whoInData.startDate > this.whoInData.endDate || !this.whoInData.startDate && this.whoInData.endDate) {
        this.$store.dispatch('showDangerAlert', this.$t('dateEndGreaterThanStart'));
      } else if (this.whoInData.participantsLimit && (isNaN(this.whoInData.participantsLimit) || this.whoInData.participantsLimit < 2)) {
        this.$store.dispatch('showDangerAlert', this.$t('participantsLimitGreaterThan2'));
      } else if (this.editingEntry && this.whoInData.participantsLimit && this.whoInData.participantsLimit < this.$store.state.forum.entryEditData.whoInData.participants.length) {
        this.$store.dispatch('showDangerAlert', this.$t('participantsLimitLowerThenCurrentParticipants', { participants: this.$store.state.forum.entryEditData.whoInData.participants.length }));
      } else {
        __WEBPACK_IMPORTED_MODULE_9__repositories_ForumRepository__["a" /* default */][this.editingEntry ? 'editWhoInEntry' : 'sendWhoInData'](this.whoInData).then(function (data) {
          if (data) {
            _this.$store.dispatch('showSuccessAlert', _this.editingEntry ? _this.$t('activityUpdatedCorrectly') : _this.$t('postPublishedCorrectly'));
            _this.$router.push(_this.getHealthyCommunityPathUrl(__WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["e" /* WHO_IN_SECTION_NAME */]));
          } else {
            _this.$store.dispatch('showDangerAlert', _this.$t('defaultErrorMessage'));
          }
        });
      }
    },
    sendForumData: function sendForumData() {
      var _this2 = this;

      if (!this.postTitle) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyTitleError'));
      } else if (this.expirationDate && new Date(this.expirationDate) <= Date.now()) {
        this.$store.dispatch('showDangerAlert', this.$t('dateMustBeGreaterThanNow'));
      } else if (this.showCategorySelector && !this.category) {
        this.$store.dispatch('showDangerAlert', this.$t('entryCategoryNotSelected'));
      } else if (this.showCategorySelector && this.category.id === DISEASE_ID && !this.disease) {
        this.$store.dispatch('showDangerAlert', this.$t('mustSelectDisease'));
      } else if (!this.wysiwygInput) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyForumContentError'));
      } else {
        var data = { title: this.postTitle.trim(), description: this.wysiwygInput, tags: this.tags, category: this.category, disease: this.disease, section: this.section, expirationDate: this.expirationDate };
        var responseMessage = function responseMessage(data) {
          if (data) {
            _this2.$store.dispatch('showSuccessAlert', _this2.$store.getters['forum/forumEntryWithoutValidation'] ? _this2.$t('postPublishedCorrectly') : _this2.$t('postPublishedCorrectlyPending'));
            _this2.$router.push(_this2.getHealthyCommunityPathUrl(__WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["c" /* PATIENTS_LIKE_YOU_IN_SECTION_NAME */]));
          } else {
            _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
          }
        };
        if (this.postImage) {
          this.$helpers.uploadFile('/Forum/CreateEntry', data, this.postImage, this).then(function (response) {
            responseMessage(response.data);
          });
        } else {
          this.$api.post('/Forum/CreateEntry', data).then(function (response) {
            responseMessage(response.data);
          });
        }
      }
    },
    getCategories: function getCategories(search, loading) {
      var _this3 = this;

      if (search) {
        loading(true);
        this.categoriesSource = this.categoriesSourceFull.filter(function (item) {
          return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
        });
        loading(false);
      } else if (this.categoriesSourceFull.length === 0) {
        this.$api.get('Forum/SearchEntryCategory').then(function (response) {
          _this3.categoriesSourceFull = response.data;
          _this3.categoriesSource = response.data;
        });
      }
    },
    getDiseases: function getDiseases() {
      var _this4 = this;

      this.$api.get('Forum/SearchEntryDisease').then(function (response) {
        _this4.diseasesSource = response.data;
      });
    },
    getSections: function getSections() {
      var _this5 = this;

      this.$api.get('Forum/GetEntrySection').then(function (response) {
        if (response) {
          _this5.sectionSource = response.data;
          if (_this5.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */] || _this5.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */] || _this5.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */]) {
            _this5.section = response.data.find(function (item) {
              return item.id === _this5.$store.state.forum.sectionId;
            });
          }
        }
      });
    },
    inputNewDisease: function inputNewDisease(disease) {
      this.disease = { id: null, name: disease.name };
    },
    categorySelected: function categorySelected(item) {
      if (item.id === DISEASE_ID) {
        this.getDiseases();
        this.showDiseaseInput = true;
      } else {
        this.showDiseaseInput = false;
        this.disease = null;
      }
    },
    getTags: function getTags(search, loading) {
      var _this6 = this;

      if (search) {
        loading(true);
        this.tagsSource = this.tagsSourceFull.filter(function (item) {
          return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
        });
        loading(false);
      } else if (this.tagsSourceFull.length === 0) {
        this.$api.get('Forum/SearchEntryTag').then(function (response) {
          _this6.tagsSourceFull = response.data;
          _this6.tagsSource = response.data;
        });
      }
    },
    activityChange: function activityChange() {
      if (this.whoInData.activity !== -1) this.whoInData.otherActivity = null;
    },
    getActivities: function getActivities() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_9__repositories_ForumRepository__["a" /* default */].getActivities().then(function (response) {
        response.data.push({ id: -1, name: _this7.$t('otherActivity'), nameEn: _this7.$t('otherActivity'), namePt: _this7.$t('otherActivity') });
        _this7.activitySource = response.data;
      });
    },
    getActivitiesLevel: function getActivitiesLevel() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_9__repositories_ForumRepository__["a" /* default */].getActivitiesLevel().then(function (response) {
        _this8.activityLevelSource = response.data;
      });
    },
    getCountries: function getCountries() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_10__repositories_GeographyRepository__["a" /* default */].getCountries().then(function (response) {
        _this9.countrySource = response.data;
      });
    },
    getStates: function getStates() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_10__repositories_GeographyRepository__["a" /* default */].getStatesByCountry(this.whoInData.country).then(function (response) {
        _this10.stateSource = response.data;
      });
    },
    getCities: function getCities() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_10__repositories_GeographyRepository__["a" /* default */].getStateCities(this.whoInData.state).then(function (response) {
        _this11.citySource = response.data;
      });
    },
    countryChange: function countryChange() {
      this.getStates();
      this.citySource = [];
      this.whoInData.state = null;
      this.whoInData.city = null;
    },
    stateChange: function stateChange() {
      this.whoInData.city = null;
      this.getCities();
    },
    updateTagsSource: function updateTagsSource() {
      var _this12 = this;

      this.tagsSourceFull = this.tagsSourceFull.filter(function (item) {
        return !_this12.tags.some(function (x) {
          return x.id === item.id;
        });
      });
      this.tagsSource = this.tagsSourceFull;
    },
    tagDeselected: function tagDeselected(tag) {
      this.tagsSourceFull.push(tag);
      this.tagsSourceFull.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.tagsSource = this.tagsSourceFull;
    },
    showSectionSelector: function showSectionSelector() {
      return location.href.indexOf('comunidadsaludable') > -1 && this.$store.state.forum.userBasicInfo.companyCode && (this.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */] || !this.$store.state.forum.sectionId);
    },
    sectionSelected: function sectionSelected() {
      if (this.section.id === __WEBPACK_IMPORTED_MODULE_11__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */]) {
        this.wysiwygInput = this.$t('whoInNewPost');
      } else {
        this.wysiwygInput = null;
      }
    },
    fillWhoInData: function fillWhoInData() {
      var _this13 = this;

      var data = this.$store.state.forum.entryEditData.whoInData;
      var keysToExclude = ['participants', 'noStartTime', 'noEndTime'];
      var activityKey = 'activity';
      this.whoInData.id = this.$store.state.forum.entryEditData.id;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).filter(function (key) {
        return !keysToExclude.includes(key);
      }).forEach(function (key) {
        if (data[key]) {
          if (key === activityKey && data[key].createdByUser) {
            _this13.whoInData.activity = -1;
            _this13.whoInData.otherActivity = data[key][_this13.normalizeForumProp('name')];
          } else {
            _this13.whoInData[key] = _this13.getWhoInPropValue(data, key);
          }
        }
      });
      this.getCountries();
      this.getStates();
      this.getCities();
    },
    getWhoInPropValue: function getWhoInPropValue(data, key) {
      var startDateKey = 'startDate';
      var endDateKey = 'endDate';
      var noStartTimeKey = 'noStartTime';
      var noEndTimeKey = 'noEndTime';
      var commentariesKey = 'commentaries';
      var value = data[key];

      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        return value.id;
      } else if (!isNaN(new Date(value))) {
        var date = new Date(value);
        if (key === startDateKey) {
          this.startDate = date.toISOString().split('T')[0];
          if (!data[noStartTimeKey]) this.startHour = date.toLocaleTimeString();
        } else if (key === endDateKey) {
          this.endDate = date.toISOString().split('T')[0];
          if (!data[noEndTimeKey]) this.endHour = date.toLocaleTimeString();
        }
        return value;
      } else if (key === commentariesKey) {
        this.wysiwygInput = value;
        return value;
      } else {
        return value;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 4309:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4310);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("18bc97dd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a74d1350\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumNewPostForm.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a74d1350\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumNewPostForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4310:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.alignLeft{text-align:left\n}\n.marginAllSide{margin:1%\n}\n.postBlock{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.postAlign{width:80vw;vertical-align:baseline;max-width:1140px\n}\n@media only screen and (max-width: 575px){\n.postAlign{width:90vw\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.postAlign{width:90vw\n}\n}\ndiv.select-margin-bottom{margin-bottom:1.5rem !important\n}\n", ""]);

// exports


/***/ }),

/***/ 4311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "postBlock" }, [
      _c(
        "div",
        { staticClass: "postAlign" },
        [
          _c("h3", { staticClass: "form-group" }, [
            _vm._v(_vm._s(_vm.getForumTitle))
          ]),
          _vm._v(" "),
          !_vm.inWhoInSection
            ? _c("base-input", {
                staticClass: "form-group",
                attrs: { placeholder: _vm.$t("enterPostTitle") },
                model: {
                  value: _vm.postTitle,
                  callback: function($$v) {
                    _vm.postTitle = $$v
                  },
                  expression: "postTitle"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.inWhoInSection
            ? _c(
                "div",
                [
                  _c("base-select", {
                    staticClass: "mb-4",
                    attrs: {
                      placeholder: _vm.$t("activity"),
                      valueProp: "id",
                      avoidDefaultSort: "",
                      options: _vm.activitySource,
                      searchable: "",
                      label: _vm.normalizeForumProp("name")
                    },
                    on: { "option:selected": _vm.activityChange },
                    model: {
                      value: _vm.whoInData.activity,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "activity", $$v)
                      },
                      expression: "whoInData.activity"
                    }
                  }),
                  _vm._v(" "),
                  _vm.otherActivitySelected
                    ? _c("base-input", {
                        staticClass: "form-group",
                        attrs: { placeholder: _vm.$t("insertActivityName") },
                        model: {
                          value: _vm.whoInData.otherActivity,
                          callback: function($$v) {
                            _vm.$set(_vm.whoInData, "otherActivity", $$v)
                          },
                          expression: "whoInData.otherActivity"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("base-select", {
                    staticClass: "mb-4",
                    attrs: {
                      placeholder: _vm.$t("level"),
                      avoidDefaultSort: "",
                      valueProp: "id",
                      options: _vm.activityLevelSource,
                      searchable: "",
                      label: _vm.normalizeForumProp("name")
                    },
                    model: {
                      value: _vm.whoInData.activityLevel,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "activityLevel", $$v)
                      },
                      expression: "whoInData.activityLevel"
                    }
                  }),
                  _vm._v(" "),
                  _c("base-input", {
                    staticClass: "form-group",
                    attrs: {
                      type: "number",
                      min: 2,
                      placeholder:
                        _vm.$t("participantsLimit") + " " + _vm.$t("optional")
                    },
                    model: {
                      value: _vm.whoInData.participantsLimit,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "participantsLimit", $$v)
                      },
                      expression: "whoInData.participantsLimit"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-4", attrs: { cols: "12", xl: "4" } },
                        [
                          _c("base-select", {
                            attrs: {
                              options: _vm.countrySource,
                              placeholder: _vm.$t("country"),
                              valueProp: "idCountry",
                              searchable: "",
                              label: _vm.$i18nHelpers.normalizeProp("name")
                            },
                            on: { "option:selected": _vm.countryChange },
                            model: {
                              value: _vm.whoInData.country,
                              callback: function($$v) {
                                _vm.$set(_vm.whoInData, "country", $$v)
                              },
                              expression: "whoInData.country"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-select", {
                            attrs: {
                              options: _vm.stateSource,
                              placeholder: _vm.$t("state"),
                              valueProp: "id",
                              searchable: "",
                              label: _vm.$i18nHelpers.normalizeProp("name")
                            },
                            on: { "option:selected": _vm.stateChange },
                            model: {
                              value: _vm.whoInData.state,
                              callback: function($$v) {
                                _vm.$set(_vm.whoInData, "state", $$v)
                              },
                              expression: "whoInData.state"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-select", {
                            attrs: {
                              options: _vm.citySource,
                              placeholder: _vm.$t("city"),
                              valueProp: "idCity",
                              searchable: "",
                              label: _vm.$i18nHelpers.normalizeProp("name"),
                              loading: false,
                              noOptionsTitle: _vm.$t("selectState")
                            },
                            model: {
                              value: _vm.whoInData.city,
                              callback: function($$v) {
                                _vm.$set(_vm.whoInData, "city", $$v)
                              },
                              expression: "whoInData.city"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("base-input", {
                    staticClass: "form-group",
                    attrs: { placeholder: _vm.$t("address") },
                    model: {
                      value: _vm.whoInData.address,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "address", $$v)
                      },
                      expression: "whoInData.address"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-4", attrs: { cols: "12", xl: "4" } },
                        [
                          _c("base-datepicker", {
                            attrs: {
                              noMarginBottom: "",
                              dateAfterNow: "",
                              resetButtton: "",
                              placeholder:
                                _vm.$t("startDate") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.startDate,
                              callback: function($$v) {
                                _vm.startDate = $$v
                              },
                              expression: "startDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-timepicker", {
                            attrs: {
                              noMarginBottom: "",
                              buttonOnly: "",
                              placeholder:
                                _vm.$t("startHour") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.startHour,
                              callback: function($$v) {
                                _vm.startHour = $$v
                              },
                              expression: "startHour"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-4", attrs: { cols: "12", xl: "4" } },
                        [
                          _c("base-datepicker", {
                            attrs: {
                              noMarginBottom: "",
                              dateAfterNow: "",
                              resetButtton: "",
                              placeholder:
                                _vm.$t("endDate") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.endDate,
                              callback: function($$v) {
                                _vm.endDate = $$v
                              },
                              expression: "endDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-timepicker", {
                            attrs: {
                              noMarginBottom: "",
                              buttonOnly: "",
                              placeholder:
                                _vm.$t("endHour") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.endHour,
                              callback: function($$v) {
                                _vm.endHour = $$v
                              },
                              expression: "endHour"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("b-form-file", {
                    staticClass: "form-group",
                    attrs: {
                      accept: ".jpg, .jpeg, .png, .gif",
                      placeholder: _vm.$t("selectImage"),
                      multiple: false,
                      "drop-placeholder": _vm.$t("drag-drop-file"),
                      "browse-text": _vm.$t("browse")
                    },
                    model: {
                      value: _vm.postImage,
                      callback: function($$v) {
                        _vm.postImage = $$v
                      },
                      expression: "postImage"
                    }
                  }),
                  _vm._v(" "),
                  _vm.showtagsSelector
                    ? _c("v-select", {
                        staticClass: "select-margin-bottom",
                        attrs: {
                          multiple: "",
                          placeholder: _vm.$t("mustEnterEntryTags"),
                          options: _vm.tagsSource,
                          filtered: "",
                          searchable: "",
                          label: _vm.normalizeForumProp("name")
                        },
                        on: {
                          "option:selected": _vm.updateTagsSource,
                          "option:deselecting": function($event) {
                            return _vm.tagDeselected($event)
                          },
                          search: _vm.getTags
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(_vm.$t("noTagsAvailables")) +
                                      "\r\n          "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1607747767
                        ),
                        model: {
                          value: _vm.tags,
                          callback: function($$v) {
                            _vm.tags = $$v
                          },
                          expression: "tags"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCategorySelector
                    ? _c("v-select", {
                        staticClass: "select-margin-bottom",
                        attrs: {
                          placeholder: _vm.$t("mustEnterEntryCategory"),
                          options: _vm.categoriesSource,
                          filtered: "",
                          searchable: "",
                          label: _vm.normalizeForumProp("name")
                        },
                        on: {
                          search: _vm.getCategories,
                          "option:selected": _vm.categorySelected
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(_vm.$t("mustEnterEntryCategory")) +
                                      "\r\n          "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          293695534
                        ),
                        model: {
                          value: _vm.category,
                          callback: function($$v) {
                            _vm.category = $$v
                          },
                          expression: "category"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDiseaseInput
                    ? _c("v-select", {
                        staticClass: "select-margin-bottom",
                        attrs: {
                          taggable: "",
                          placeholder: _vm.$t("enterOrSearchDiseases"),
                          options: _vm.diseasesSource,
                          filtered: "",
                          searchable: "",
                          label: "name"
                        },
                        on: { "option:created": _vm.inputNewDisease },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(_vm.$t("enterOrSearchDiseases")) +
                                      "\r\n          "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3232003289
                        ),
                        model: {
                          value: _vm.disease,
                          callback: function($$v) {
                            _vm.disease = $$v
                          },
                          expression: "disease"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          _c("vue-editor", {
            staticClass: "wysiwygStyle form-group",
            attrs: {
              placeholder: _vm.inWhoInSection
                ? _vm.$t("commentaries")
                : _vm.$t("newPostDescription"),
              useCustomImageHandler: ""
            },
            on: { "image-added": _vm.handleImageAdded },
            model: {
              value: _vm.wysiwygInput,
              callback: function($$v) {
                _vm.wysiwygInput = $$v
              },
              expression: "wysiwygInput"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10%", "margin-top": "3%" } },
            [
              _c("base-button", { on: { click: _vm.sendForumForm } }, [
                _vm._v(_vm._s(_vm.$t("send")))
              ]),
              _vm._v(" "),
              _c(
                "base-button",
                { attrs: { gray: "", outline: "" }, on: { click: _vm.back } },
                [_vm._v(_vm._s(_vm.$t("back")))]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a74d1350", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/79.e8dd951d06310df9e50f.js